;(function ($) {
  "use strict";

  $(document).ready(function () {
    $('.royalSlider').royalSlider({
      imageScaleMode: 'fill',
      imageScalePadding: 0,
      slidesSpacing: 0,
      loop: true,
      navigateByClick: false,
      autoPlay: {
        enabled: true,
        pauseOnHover: true,
        stopAtAction: false,
        delay: 4000
      }
    });
  });
})(jQuery);
